import { useAccount } from '~teacher/hook/account';

import { rosterLimitsByPlan } from '../../../../../../shared/src/utils/rosterLimits/rosterLimitsByPlan';

export function useMaxRosterSize() {
  return useAccount({
    select: ({ plan }) => {
      return rosterLimitsByPlan(plan);
    },
  });
}
